import { BehaviorSubject, defer } from 'rxjs';
const persistStorageKey = 'settings';
export class SettingController {
    get value() {
        return this.valueState$.value;
    }
    constructor(name, initValue = null) {
        this.name = name;
        this.initValue = initValue;
        this.value$ = defer(() => this.valueState$);
        this.originalValue = null;
        this.valueState$ = new BehaviorSubject(initValue);
    }
    async init(context) {
        this.context = context;
        const next = this.getPersistValue() ?? this.initValue;
        if (next === null)
            return;
        this.setValue(next);
    }
    setValue(value) {
        this.valueState$.next(value);
        this.updatePersist(value);
    }
    resetValue() {
        this.valueState$.next(this.originalValue);
        this.updatePersist(this.originalValue);
    }
    cleanValue() {
        this.valueState$.next(null);
        this.updatePersist(null);
    }
    startChangingValue() {
        if (this.originalValue !== null) {
            throw new Error('value changing in progress');
        }
        this.originalValue = this.value;
    }
    endChangingValue() {
        this.originalValue = null;
    }
    updatePersist(value) {
        if (!this.context)
            throw new Error('SettingController.updatePersist Error:  context is not initialized');
        this.context.storage.updateEntity(persistStorageKey, this.name, value);
    }
    getPersistValue() {
        if (!this.context)
            throw new Error('SettingController.getPersistValue Error: context is not initialized');
        return this.context.storage.getEntityValue(persistStorageKey, this.name);
    }
}
//# sourceMappingURL=setting.controller.js.map